<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  settingsPanel
  footerNav
</template>

<script>
import toolBar from "@/components/mobile/toolBar";
import settingsPanel from "@/components/mobile/account/settingsPanel";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config"

export default {
  components: {
    toolBar,
    settingsPanel,
    footerNav,
    Marquee
  },
  data() {
    return {
      betting: {
        defaultStake: "0",
        acceptBetterOdds: "true",
        acceptAnyOdds: "false",
        autoRefreshOdds: "true",
        quickBet: "false",
        defaultStakeAmount: "1"
      },
      pageDisplay: {
        language: "en",
        oddsType: config.defaultOdds,
        pageType: "2",
        showScoreMap: "false",
        eventSorting: "1",
        marketType: "1",
        pageSize: "10"
      },
      order: []
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    defineOrder() {
      return this.$store.state.layout.order.sports;
    },
    defaultOrder() {
      return Object.keys(this.$store.state.layout.sports);
    }
  },
  mounted() {},
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    save() {
      this.formData();

      this.$store
        .dispatch("user/setSettings", {
          page_display: JSON.stringify(this.pageDisplay),
          sports_order: JSON.stringify(this.order),
          betting: JSON.stringify(this.betting)
        })
        .then(
          res => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
            this.$router.push("/mobile");
          },
          err => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
          }
        );


    },
    formData() {
      if (this.defineOrder.length > 0) {
        this.order = this.defineOrder;
      } else {
        this.order = this.defaultOrder;
      }

      if (typeof this.$store.getters.betting.defaultStake !== "undefined") this.betting.defaultStake = this.$store.getters.betting.defaultStake;

      if (typeof this.$store.getters.betting.acceptBetterOdds !== "undefined") this.betting.acceptBetterOdds = this.$store.getters.betting.acceptBetterOdds;

      if (typeof this.$store.getters.betting.acceptAnyOdds !== "undefined") this.betting.acceptAnyOdds = this.$store.getters.betting.acceptAnyOdds;

      if (typeof this.$store.getters.betting.autoRefreshOdds !== "undefined") this.betting.autoRefreshOdds = this.$store.getters.betting.autoRefreshOdds;

      if (typeof this.$store.getters.betting.quickBet !== "undefined") this.betting.quickBet = this.$store.getters.betting.quickBet;

      if (typeof this.$store.getters.betting.defaultStakeAmount !== "undefined") this.betting.defaultStakeAmount = this.$store.getters.betting.defaultStakeAmount;

      if (typeof this.$store.getters.language !== "undefined") this.pageDisplay.language = this.$store.getters.language;

      if (typeof this.$store.getters.pageDisplay.oddsType !== "undefined") this.pageDisplay.oddsType = this.$store.getters.pageDisplay.oddsType;

      if (typeof this.$store.getters.pageDisplay.pageType !== "undefined") this.pageDisplay.pageType = this.$store.getters.pageDisplay.pageType;

      if (typeof this.$store.getters.pageDisplay.showScoreMap !== "undefined") this.pageDisplay.showScoreMap = this.$store.getters.pageDisplay.showScoreMap;

      if (typeof this.$store.getters.pageDisplay.eventSorting !== "undefined") this.pageDisplay.eventSorting = this.$store.getters.pageDisplay.eventSorting;

      if (typeof this.$store.getters.pageDisplay.marketType !== "undefined") this.pageDisplay.marketType = this.$store.getters.pageDisplay.marketType;

      if (typeof this.$store.getters.pageDisplay.pageSize !== "undefined") this.pageDisplay.pageSize = this.$store.getters.pageDisplay.pageSize;
    }
  }
};
</script>
